export enum NotifyType {
    Info,
    Warning,
    Success,
    Error,
}
